<!-- template v.0 -->
<!--<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
  <router-view/>
</template>
-->
<template>
  <div class="container-fluid" v-if="content.token">
    <div class="row">
  
  <div v-show="content.sistema" class="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-rojo">
      <Menu :content="content" ></Menu>  
        
  </div>
  <router-view :content="content"> </router-view> 
  <div v-show="content.login">
      
  </div>
    </div>
  </div>
  <Login v-if="!content.token" :content="content"></Login> 
</template>

<script>

import Menu from "./views/Layout/Menu";
import Login from "./views/Login";
export default {
  components: {
    Menu,Login
  },
 data: function () {
    return {
      content: {
      login:false,
      sistema:false,
      token:(localStorage.token)?true:false
      }
    }
 },
 mounted(){

 }
}
</script>
<!-- style v.0 -->
<!--<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
-->
<style scoped>
@import './assets/css/style.css';
</style>